import axios from "axios";

export const HTTP = axios.create({
  baseURL: `http://127.0.0.1:3001/api/v1/`,
  headers: {
    authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});
